import React, { useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as InfoIcon } from "images/info.svg";
import { formatEUR } from "utils/number";

export default function BonusTerritorial({ montantBonusTerritorial }) {
  const [isShown, setShown] = useState(false);

  // Le bonus territorial n'est accordé qu'aux communes adhérentes : on
  // n'affiche rien pour les autres.
  if (montantBonusTerritorial <= 0) {
    return null;
  }

  return (
    <div
      className="success-item-right no-border"
      style={{ borderWidth: ["1px", 0, 0, 0] }}
    >
      <div>
        {/* Même structure que la ligne "Prime Sorégies" (InfoHoverBlock),
            déclinée en vert Sorégies. */}
        <div
          className="info-block-container"
          onClick={() => setShown(!isShown)}
          onMouseEnter={() => setShown(true)}
          onMouseLeave={() => setShown(false)}
        >
          <p className="p2 text-vert-soregies">
            <span>Bonus Territorial</span>
            <span className="iconColor2">
              <InfoIcon />
            </span>
          </p>
          {isShown && (
            <div className="info-block">
              <div>
                <p>
                  <strong>Le bonus territorial</strong> : est une aide
                  complémentaire versée par Sorégies aux habitants des communes
                  adhérentes.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div>
        <h5
          className="h5-prime whitespace-nowrap !bg-vert-soregies"
          style={{ fontSize: "20px" }}
        >
          - {formatEUR(montantBonusTerritorial)}
        </h5>
      </div>
    </div>
  );
}
BonusTerritorial.propTypes = {
  montantBonusTerritorial: PropTypes.number,
};
